import { render, staticRenderFns } from "./Inside.vue?vue&type=template&id=2e9780a6&scoped=true"
import script from "./Inside.vue?vue&type=script&lang=js"
export * from "./Inside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9780a6",
  null
  
)

export default component.exports